const isNewVersion = () => {
  const VUE_APP_VERSION = require('../../package.json').version
  const vers = window.localStorage.getItem('appVersion')
  if (VUE_APP_VERSION != vers) {
    localStorage.clear()
    window.localStorage.setItem('appVersion', VUE_APP_VERSION)
    location.reload()
  }
}

export default {
    isNewVersion
}



// WEBPACK FOOTER //
// ./src/utils/versionUpdate.js